import React from "react";

import {
  NavigationMenu,
  NavigationMenuItem,
  NavigationMenuLink,
  NavigationMenuList,
  navigationMenuTriggerStyle,
} from "../ui/navigation-menu";
import NavItem from "./NavItem";
import WhatsNewLink from "./WhatsNewLink";
import {
  ADMIN_ITEMS,
  ANNUAL_REPORTS_ITEMS,
  INSTRUCTIONS_PLUGINS_ITEMS,
  LEAD_VIEWS_ITEMS,
  SCORING_FILTERS_ITEMS,
} from "./utils";

const Navigation = ({ hasUnreadNews }: { readonly hasUnreadNews: boolean }) => {
  return (
    <NavigationMenu className="hidden xl:flex">
      <NavigationMenuList>
        <NavItem type="single" href="/pluto" title="Pluto" />
        <NavItem type="single" href="/" title="Companies" />
        <NavItem type="single" href="/domains" title="Domains" />
        <NavigationMenuItem>
          <NavigationMenuLink asChild>
            <WhatsNewLink hasUnread={hasUnreadNews} className={navigationMenuTriggerStyle()} />
          </NavigationMenuLink>
        </NavigationMenuItem>
        <NavItem type="menu" title="Lead views" menuItems={LEAD_VIEWS_ITEMS} />
        <NavItem type="single" href={SCORING_FILTERS_ITEMS[0]!.href} title={SCORING_FILTERS_ITEMS[0]!.title} />
        <NavItem type="menu" title="Annual Reports" menuItems={ANNUAL_REPORTS_ITEMS} />
        <NavItem type="menu" title="Instructions / Plugins" menuItems={INSTRUCTIONS_PLUGINS_ITEMS} />
        <NavItem type="menu" title="Admin" menuItems={ADMIN_ITEMS} />
      </NavigationMenuList>
    </NavigationMenu>
  );
};

export default Navigation;
